import icon from '../../assets/phone.png'
import { BaseIcon } from './BaseIcon'

export const PhoneIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <BaseIcon icon={icon} onClick={onClick} />
  );
}
